import { Component } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AppConfigService } from '../../../../app-config.service';
import { CapaciteStepEnum } from '../../constants/capacite-step.enum';
import { StatusCapaciteEnum } from '../../constants/status-capacite.enum';
import { TypeProprieteEnum } from '../../constants/type-propriete.enum';
import { DEBUG_CAPACITE } from './debug.data';
import { CapaciteSelectors } from '../../capacite.selectors';
import { GoToStep, NavigatePageFormulaire, PatchCapaciteDebugOnly } from '../../capacite.actions';

@Component({
  selector: 'app-debug',
  templateUrl: './debug.component.html',
  standalone: false
})
export class DebugComponent {
  readonly statusCapaciteValues = Object.values(StatusCapaciteEnum);
  readonly stepValues = Object.values(CapaciteStepEnum).filter(value => typeof value === 'string');
  CapaciteStepEnum = CapaciteStepEnum;

  @Select(CapaciteSelectors.statutCapacite)
  statutCapacite$: Observable<StatusCapaciteEnum>;

  constructor(private readonly store: Store, private readonly appConfigService: AppConfigService) {}

  changeStatut(value: StatusCapaciteEnum | string) {
    const capacite = { ...DEBUG_CAPACITE, typeCapacite: this.appConfigService.typeProjet };

    let isCompleted = true;
    switch (value) {
      case StatusCapaciteEnum.Basse:
        capacite.montantPretRealiste = 0;
        break;
      case StatusCapaciteEnum.Haute:
        capacite.valeurProprieteRealiste = 1000000;
        break;
      case StatusCapaciteEnum.RealisteEgaleMaximale:
        capacite.valeurProprieteRealiste = capacite.valeurProprieteMaximale = 500000;
        break;
      case StatusCapaciteEnum.Debute:
        capacite.typePropriete = TypeProprieteEnum.Maison;
        isCompleted = false;
        break;
      case StatusCapaciteEnum.Vide:
        isCompleted = false;
        break;
    }

    this.store.dispatch(new PatchCapaciteDebugOnly(capacite as any, isCompleted));
  }

  changeCurrentStep(step: CapaciteStepEnum) {
    this.store.dispatch(
      new PatchCapaciteDebugOnly({ ...DEBUG_CAPACITE, typeCapacite: this.appConfigService.typeProjet } as any, false)
    );
    this.store.dispatch(new GoToStep(step));
    this.store.dispatch(new NavigatePageFormulaire());
  }
}
